// actions.js

import axios from 'axios';


export default {
    async fetchRemoteConfigByDevice(ctx, {id}){
        const access_token = ctx.rootGetters.access_token;
        const config = {
            headers: {
                'Authorization': `${access_token}`
            }
        };
        try {
            const response = await axios.get(`${process.env.VUE_APP_APIGATEWAY}/api/v1/remote-configs/by-device/${id}`, config);
            return response.data
        } catch (error) {
            return error;
        }
    },
    async fetchRemoteConfigsByDeviceIds(ctx, payload){
        const access_token = ctx.rootGetters.access_token;
        const response = await axios.post(
            `${process.env.VUE_APP_APIGATEWAY}/api/v1/remote-configs/by-device-ids`,
            {
                device_ids:payload
            },
            {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `${access_token}`
                },
            }
        );
        if(response.data){
            ctx.commit('updateRemoteConfigs', response.data)
        } else {
            ctx.commit('updateRemoteConfigs', [])
        }
    },
    async fetchSaveRemoteConfig(ctx, payload){
        try{
            const access_token = ctx.rootGetters.access_token;
            const response = await axios.post(
                `${process.env.VUE_APP_APIGATEWAY}/api/v1/remote-configs`,
                payload,
                {
                    headers: {
                        'Authorization': `${access_token}`
                    }
                }
            );
            return {
                status: response.status,
                data: response.data
            };
        } catch (error) {
            if (error.response) {
                // Сервер вернул ответ с ошибкой (код статуса не в диапазоне 2xx)
                return {
                    status: error.response.status,
                    message: error.response.data.message || 'Registration failed'
                };
            } else if (error.request) {
                // Запрос был сделан, но ответа не получено
                return {
                    status: 0,
                    message: 'No response received from server'
                };
            } else {
                // Что-то пошло не так при настройке запроса
                return {
                    status: -1,
                    message: error.message
                };
            }
        }
        
    },
    async fetchUpdateRemoteConfig(ctx, payload){
        try{
            const access_token = ctx.rootGetters.access_token;
            const response = await axios.patch(
                `${process.env.VUE_APP_APIGATEWAY}/api/v1/remote-configs/by-device/${payload.device_id}`,
                {
                    config_data: payload.config_data,
                },
                {
                    headers: {
                        'Authorization': `${access_token}`
                    }
                }
            );
            return {
                status: response.status,
                data: response.data
            };
        } catch (error) {
            if (error.response) {
                // Сервер вернул ответ с ошибкой (код статуса не в диапазоне 2xx)
                return {
                    status: error.response.status,
                    message: error.response.data.message || 'Registration failed'
                };
            } else if (error.request) {
                // Запрос был сделан, но ответа не получено
                return {
                    status: 0,
                    message: 'No response received from server'
                };
            } else {
                // Что-то пошло не так при настройке запроса
                return {
                    status: -1,
                    message: error.message
                };
            }
        }

    },
};
